import { DTO } from '../../utilities/Dto';

export interface Label {
  recnum: number;
  name: string;
  description: string;
  color: string | null;
  tickets: boolean;
  lists: boolean;
  created: Date; // Parsed Date object
  modified: Date; // Parsed Date object
  deleted: boolean;
  editor_user_id: number;
}

export function parseLabelDto(label: DTO<Label>): Label {
  return {
    ...label,
    created: new Date(label.created),
    modified: new Date(label.modified),
  };
}
